import React from "react";
import "./featured.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight, faHeart } from "@fortawesome/free-solid-svg-icons";
import ShopNow from "../Shopnow/ShopNow";
// import Team from "../Team/Team";
import { Link } from "react-router-dom";
import { HiMiniArrowLongRight } from "react-icons/hi2";

const Featured = () => {
  const data = [
    {
      btnname: "Traditional collection",
      titlename: "Explore",
      delprice: "150$",
      price: "120$",
      heartno: 23,
      img: "./images/raw/sacred.webp",
    },
  ];
  const data2 = [
    {
      btnname: "Limited edition",
      titlename: "Explore",
      delprice: "150$",
      price: "120$",
      heartno: 23,
      img: "./images/raw/opulent.webp",
    },
  ];
  const data3 = [
    {
      btnname: "Antique Collection",
      titlename: "Explore",
      delprice: "150$",
      price: "120$",
      heartno: 23,
      img: "./images/raw/antique.webp",
    },
  ];
  const data4 = [
    {
      btnname: "Petals Collection",
      titlename: "Explore",
      delprice: "150$",
      price: "120$",
      heartno: 23,
      img: "./images/raw/bloom.webp",
    },
  ];
  const data5 = [
    {
      btnname: "Gemstone Collection",
      titlename: "Explore",
      delprice: "150$",
      price: "120$",
      heartno: 23,
      img: "./images/raw/wings.webp",
    },
  ];

  // const data6 = [
  //   {
  //     btnname: "limited edition",
  //     titlename: "Goldtone Bib",
  //     delprice: "150$",
  //     price: "120$",
  //     heartno: 23,
  //     img: "./images/raw/s6.jpg",
  //   },
  // ];
  let divno = "coll-1";
  let div = "coll-2";

  return (
    <section className="">
      <div className="flex lg:flex-row md:flex-col max-sm:flex-col sm:flex-col mb-1">
        <div className="lg:w-[50%] md:w-[100%] max-md:w-[100%] sm:w-[100%] max-sm:w-full relative">
          <div
            id="align-text"
            className="lg:pl-[18px] mx-10 md:pl-[23px] md:pt-[25px]  max-sm:px-[20px] text-[16px] leading-8 "
          >
            <span
              id="title"
              class="block text-[22px] leading-[26px] text-tertary2 font-semibold tracking-[2px] mb-[22px] pb-[14px] relative uppercase"
            >
              featured products
            </span>
            <h4 className="max-sm:mb-[20px] lg:text-[40px] max-sm:text-[40px] lg:leading-[70px] max-sm:leading-[50px] text-tertary2 uppercase font-bold">
              romantic
            </h4>
            <p className="lg:w-[100%] md:w-[100%] text-lg text-black max-sm:mb-[10px]">
              Look over the sculpted pieces of finished brilliance. Begins as a
              raw gold, melted, shaped, and refined by hands to understand the
              language of love. The calibrated curves, polished and incubated
              with patience, tell an everlasting and meaningful story. Our
              artisans sculpt promises drawn from the depth of our rooted
              heritage. The creations, crafted with precision become the poetry
              your love story wears.
            </p>
            <Link
              to="/about"
              className="text-slate-900 text-[18px] leading-5 flex py-2 group"
            >
              Continue
              <HiMiniArrowLongRight className="text-2xl ml-1 transition-transform duration-300 transform group-hover:translate-x-2" />
            </Link>
          </div>
        </div>
        <div className="lg:w-[50%] md:w-[100%] max-md:w-[100%] sm:w-[100%] max-sm:w-full">
          <ShopNow data={data} div={div} />
          <ShopNow data={data2} div={div} />
        </div>
      </div>

      <section className="flex lg:flex-row md:flex-row max-sm:flex-col sm:flex-col bg-black">
        <div className="">
          <ShopNow data={data3} div={divno} />
        </div>

        <div className="">
          <div className="flex md:flex-col max-sm:flex-col sm:flex-col bg-black">
            <div>
              <ShopNow data={data4} div={div} />
              <ShopNow data={data5} div={div} />
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Featured;
